// Phones (under 720px) get a shorter notice and settings sheet; 720px and up
// keep the original wording. Each text carries both versions, and
// klaro-theme.css shows .gp-wide or .gp-narrow by width. {learnMoreLink} puts
// Klaro's "Customise" link inside the phone paragraph; the theme hides it on
// wider screens, where the Customise button beside Reject all is used.
const fullDescription = "We use cookies to run the site, see what's working, and show GYMPODS to people who might be interested. By clicking 'Accept all', you consent to our use of cookies. <a href='/cookies'>Read our cookie policy</a>."
const noticeDescription =
  `<span class="gp-wide">${fullDescription}</span>` +
  "<span class=\"gp-narrow\">We use cookies to see what's working and to show GYMPODS to people who might like it. <a href='/cookies'>Cookie policy</a>&nbsp;·&nbsp;</span>{learnMoreLink}"
const modalTitle =
  '<span class="gp-wide">We value your privacy</span><span class="gp-narrow">Choose your cookies</span>'
const modalDescription =
  `<span class="gp-wide">${fullDescription}</span>` +
  "<span class=\"gp-narrow\"><a href='/cookies'>Cookie policy</a></span>"

export default {
  version: 1,
  elementID: 'klaro',
  storageMethod: 'cookie',
  cookieName: 'gympods-consent',
  cookieExpiresAfterDays: 180,
  default: false,
  mustConsent: false,
  acceptAll: true,
  hideDeclineAll: false,
  noticeAsModal: false,
  htmlTexts: true,
  disablePoweredBy: true,
  showNoticeTitle: true,

  translations: {
    zz: {
      privacyPolicyUrl: '/privacy',
      consentModal: {
        title: modalTitle,
        description: modalDescription
      },
      consentNotice: {
        title: 'We value your privacy',
        changeDescription: 'Our cookies have changed since your last visit, please renew your consent.',
        description: noticeDescription,
        learnMore: 'Customise'
      },
      acceptAll: 'Accept all',
      acceptSelected: 'Save choices',
      decline: 'Reject all',
      ok: 'Accept all',
      save: 'Save choices',
      close: 'Close',
      poweredBy: '',
      service: {
        required: { title: 'Always on' }
      },
      purposes: {
        necessary: {
          title: 'Necessary',
          description: 'Keeps you signed in, remembers your booking and makes sure pages load.'
        },
        analytics: {
          title: 'Analytics',
          description: 'Shows us which pages work, so we can improve them. Google Analytics and Microsoft Clarity (anonymised session replays).'
        },
        marketing: {
          title: 'Marketing',
          description: 'Lets us show GYMPODS to people who might like it, and see which ads work. Meta and Google.'
        }
      }
    },
    en: {
      privacyPolicyUrl: '/privacy',
      consentModal: {
        title: modalTitle,
        description: modalDescription
      },
      consentNotice: {
        title: 'We value your privacy',
        changeDescription: 'Our cookies have changed since your last visit, please renew your consent.',
        description: noticeDescription,
        learnMore: 'Customise'
      },
      acceptAll: 'Accept all',
      acceptSelected: 'Save choices',
      decline: 'Reject all',
      ok: 'Accept all',
      save: 'Save choices',
      close: 'Close',
      poweredBy: '',
      service: {
        required: { title: 'Always on' }
      },
      purposes: {
        necessary: {
          title: 'Necessary',
          description: 'Keeps you signed in, remembers your booking and makes sure pages load.'
        },
        analytics: {
          title: 'Analytics',
          description: 'Shows us which pages work, so we can improve them. Google Analytics and Microsoft Clarity (anonymised session replays).'
        },
        marketing: {
          title: 'Marketing',
          description: 'Lets us show GYMPODS to people who might like it, and see which ads work. Meta and Google.'
        }
      }
    }
  },

  // Consent Mode updates for these services are sent from main.js (sendConsent),
  // once per choice, after the tap has painted.
  services: [
    {
      name: 'necessary-stripe',
      title: 'Stripe (payment processing)',
      purposes: ['necessary'],
      required: true,
      cookies: [
        [/^__stripe_/, '/', 'gympods.com']
      ]
    },
    {
      name: 'ga4',
      title: 'Google Analytics 4',
      purposes: ['analytics'],
      default: false,
      cookies: [
        [/^_ga/, '/', 'gympods.com'],
        [/^_ga_/, '/', 'gympods.com']
      ]
    },
    {
      name: 'clarity',
      title: 'Microsoft Clarity',
      purposes: ['analytics'],
      default: false,
      cookies: [
        [/^_clck/, '/', 'gympods.com'],
        [/^_clsk/, '/', 'gympods.com'],
        ['CLID', '/', '.clarity.ms'],
        ['ANONCHK', '/', '.clarity.ms'],
        ['MUID', '/', '.clarity.ms'],
        ['MR', '/', '.clarity.ms']
      ]
    },
    {
      name: 'meta-pixel',
      title: 'Meta Pixel',
      purposes: ['marketing'],
      default: false,
      cookies: [
        [/^_fbp/, '/', 'gympods.com'],
        [/^_fbc/, '/', 'gympods.com']
      ]
    },
    {
      name: 'google-ads',
      title: 'Google Ads',
      purposes: ['marketing'],
      default: false,
      cookies: [
        [/^_gcl_/, '/', 'gympods.com']
      ]
    }
  ]
};
